.overviewItem {
  composes: border from '../../routes/overview/Overview.css';
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem;
  /* margin-bottom: 2rem; */
  height: 9rem;
  /* width: 20vw; */
  background-color: white;
  transition: all 0.3s ease;
}

.overviewItem:hover {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  transform: var(--scale-card);
}

.topRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.label {
  margin-right: 0.5rem;
}

.icon {
  height: 3.5rem;
  width: 3.5rem;
  align-self: center;
  border: 1px solid #dad9d9;
  border-radius: 20rem;
  padding: 0.5rem;
}

@media only screen and (max-width: 550px) {
  .overviewItem {
    height: 10rem;
    width: 14rem;
  }

  .icon {
    height: 3.4rem;
    width: 3.4rem;
  }
}
